
import { contentCategoryEnum } from 'pawpaddock-common/data/content'

export default {
  name: 'TermsAndConditions',

  data() {
    return {
      type: contentCategoryEnum.TERMS,
      getContentApi: new this.$ApiModel()
    }
  },

  created() {
    this.getContent()
  },

  methods: {
    async getContent() {
      try {
        await this.$api.content(this.getContentApi).getDoc(this.type)
      } catch (error) {
        this.$log.error('Error getting terms', error)

        this.$notify.error('Error loading terms and conditions, please reload and try again')
      }
    }
  }
}
